module.exports = __webpack_public_path__ + "assets/img/right-title-open-cdf5a1f7.png";